<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center">
              <h4 class="card-tittle">{{ $t("credits.creditsGranted.title") }}</h4>
            </b-row>
            <b-row>
              <b-col sm="12" md="6" lg="3">
                <select-rut v-model="rutEmpresa" @change="getCredits" />
              </b-col>
              <b-col sm="12" md="6" lg="6" offset-lg="3">
                <b-form-group
                  label="Rango de fechas"
                  label-for="formrow-name-input"
                >
                  <date-picker
                    v-model="daterange"
                    range
                    append-to-body
                    :lang="lang"
                    confirm
                    format="DD-MM-YYYY"
                    @change="getCredits"
                  ></date-picker>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" md="6" lg="3">
                <b-form-group
                  :label="$t('credits.creditsGranted.grantedAmount')"
                  label-for="grantedAmount"
                >
                  <b-form-input
                    id="grantedAmount"
                    :value="'$ ' + getCurrency(creditData.lineaCredito)"
                    disabled
                  >
                  </b-form-input>
                </b-form-group>
                <b-form-group
                  :label="$t('credits.creditsGranted.consumedAmount')"
                  label-for="consumedAmount"
                >
                  <b-form-input
                    id="consumedAmount"
                    :value="'$ ' + getCurrency(creditData.deuda)"
                    disabled
                  >
                  </b-form-input>
                </b-form-group>
                <b-form-group
                  :label="$t('credits.creditsGranted.availableBalance')"
                  label-for="availableBalance"
                >
                  <b-form-input
                    id="availableBalance"
                    :value="'$ ' + getCurrency(creditData.saldo)"
                    disabled
                  >
                  </b-form-input>
                </b-form-group>
                <b-button
                  variant="danger"
                  @click="goCreditsConsumed()"
                  >
                  {{$t('credits.creditsGranted.seeDetail')}}
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import SelectRut from "@/components/select-rut";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import axios from "../../../axios";
import DPConfig from "../../../components/dataPickerConf";
import {formatCurrency} from "../../../utils";

export default {
  components: {
    Layout,
    "select-rut": SelectRut,
    DatePicker,
  },
  data() {
    return {
      lang: {
        formatLocale: DPConfig.formatLocale
      },
      daterange: [new Date("2000-01-01"), new Date()],
      rutEmpresa: '',
      creditData: []
    }
  },
  methods:{
    goCreditsConsumed(){
      this.$router.push({name: 'creditsConsumed'});
    },
    getCredits() {
      const fechaDesde = moment(this.daterange[0]).format("YYYY-MM-DD")
      const fechaHasta = moment(this.daterange[1]).format("YYYY-MM-DD")
      axios.get(`GetConvenios?RutEmpresa=${this.rutEmpresa}&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`)
        .then((response) => {
          this.creditData = response.data[0]
        })
    },
    getCurrency(inport) {
      return formatCurrency(inport);
    },
  }
};
</script>

<style>
</style>
